import {
  Injectable
} from '@angular/core';

import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';

import {
  AuthenticationService
} from './authentication.service';

import * as decode from 'jwt-decode';
import { EntityManagerProvider } from '../entity-manager-provider/entity-manager-provider';
import { PermisosService } from './permisos.service';

@Injectable()
export class RoleGuardService implements CanActivate {

  constructor(
	  private authService: AuthenticationService,
	  private router: Router,
	  public entityManager: EntityManagerProvider,
	  public permisosService: PermisosService)
	{}

  	async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

	const userId = this.authService.getIdUsuario();
	const that = this;

	return this.entityManager.getFUNCIONALIDADESbyUSUARIO(userId)
	.then(function(funcionalidades){

		// decode the token to get its payload
		const token = that.authService.getToken();
		const tokenPayload = decode(token);

		// Si no se restringe el acceso se deja acceder
		const expectedRole = route.data.expectedRole;
		if (expectedRole === null || expectedRole === '' || typeof(expectedRole) === 'undefined') {
			return true;
		}

		// Vamos a comprobar si el usuario tiene las funcionalidades esperadas
		let accesible = false;
		route.data.expectedRole.forEach(element => {
			try {

				const func = funcionalidades.find( x => x.FUNCIONALIDAD.Nombre === element);
				if (func.Tipo !== 0){
					accesible = true;
				}

			} catch (error) {
				accesible = false;
			}

		});

		if (!that.authService.isAuthenticated()) {
			that.router.navigate(['']);
			return false;
		} else if (tokenPayload.role === null || tokenPayload.role === '' || typeof(tokenPayload.role) === 'undefined') {
			that.router.navigate(['']);
			return false;
		} else if (accesible) {
			// that.router.navigate(['']);
			return true;
		} else {
			return false;
		}
	});


  }

  checkLogin(url: string): boolean {
    if (this.authService.isAuthenticated || url === '/') {
      return true;
    }

    // Store the attempted URL for redirecting
    this.authService.redirectUrl = url;

    // Navigate to the login page with extras
    this.router.navigate(['/']);

    return false;
  }
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/providers/authentication/role-guard.service.ts